import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import moment from 'moment'
export default {
  name: 'shipment-rule-details',
  components: {
    Paginate,
    VueElementLoading,
    BasicSelect,
    DatePicker
  },
  props: [],
  data() {
    return {
      shipmentruleaction: 'add',
      ShowShipmentRuleList: false,
      ShowShipmentRuleForm: true,
      isLoading: false,
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      ShipmentRuleDetails: [],
      RuleDetails: [],
      servicetypeArray: ['Normal', 'SFC', 'SC', 'Open', 'LH', 'AC', 'NDD/SDD/QSR', 'ToBeRTO', 'HV'],
      rulelist: [],
      ruleitem: {
        id: '',
        text: ''
      },
      len: 0,
      shipmentid: '',
      routemode: '',
      ruleid: '',
      shipmenttype: '',
      ordertype: '',
      servicetype: '',
      minimumweight: '',
      maximumweight: '',
      minimumamount: '',
      maximumamount: '',
      effectivefromdate: '',
      expirydate: '',
      COD: '',
      prepaid: '',
      isactive: '',
      addmodalshow: false,
      modalShow: false,
      modaldata: '',
      Rulename: '',
      //for Add Rule Form
      ActiveInactiveRuleDetails: [],
      ruleaction: '',
      DisplayAddRuleForm: false,
      displayrulelist: false,
      RuleName: '',
      isRuleNameError: '',
      RuleNameerrors: '',
      IsActive: false,
      createdBy: '',
      addRulemodal: false,
      Rulemodal: false,
      rulemodaldata: '',
      minweightError: '',
      maxweightError: '',
      minamountError: '',
      maxamountError: '',
      userData:[],
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.pageno = 0;
    this.getRuleList()
    this.getActiveInactiveRuleDetails()
  },
  methods: {
    SelectRule(ruleitem) {
      this.ruleitem = {
        id: '',
        text: ''
      }
      this.ruleitem = ruleitem;
      this.Rulename = this.ruleitem.text
      this.getShipmentRouteDetailsList()
      this.ShipmentRuleDetails = []
      this.routemode = ''
      this.$validator.reset()
    },
    getActiveInactiveRuleDetails() {
      this.isLoading = true;
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchShipmentRules?includeInactive=true',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.ActiveInactiveRuleDetails = result.data.ResponseData;
            let totalRows = result.data.ResponseData.length
            if (totalRows < 10) {
              this.pageCountrule = 1
            } else {
              this.pageCountrule = Math.ceil(totalRows / 10);
            }
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getRuleList() {
      this.rulelist = []
      this.isLoading = true;
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchShipmentRules',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.RuleDetails = result.data.ResponseData;
            for (var i = 0; i < this.RuleDetails.length; i++) {
              this.rulelist.push({
                "id": this.RuleDetails[i].ruleid,
                "text": this.RuleDetails[i].rulename
              })
            }
            let totalRows = result.data.ResponseData.length
            if (totalRows < 10) {
              this.pageCountrule = 1
            } else {
              this.pageCountrule = Math.ceil(totalRows / 10);
            }
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getPaginationDataForRule(pageNumrule) {
      this.pageNo = (pageNumrule - 1) * 10;
      this.getRuleList();
    },
    ShowAddRuleForm() {
      this.ruleaction = 'add'
      this.DisplayAddRuleForm = true;
      this.displayrulelist = true;
      this.RuleName = '';
      this.IsActive = false;
      this.ShowShipmentRuleList = false;
      this.ShowShipmentRuleForm = false;
    },
    checkRuleName() {
      if (this.RuleName != '') {
        this.isRuleNameError = ''
        this.RuleNameerrors = ''
      } else {
        this.isRuleNameError = '1'
        this.RuleNameerrors = 'The Rule Name field is required.'
      }
    },
    addRule() {
      this.IsActive = this.IsActive === true ? true:false;
      if (this.RuleName != '') {
        this.isRuleNameError = ''
        this.RuleNameerrors = ''
      } else {
        this.isRuleNameError = '1'
        this.RuleNameerrors = 'The Rule Name field is required.'
      }
      this.input = {
        "rulename": this.RuleName,
        "createdby": this.createdBy,
        "isActive": this.IsActive
      }
      if (this.RuleName != '') {
        this.isLoading = true;
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'addShipmentRule',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then((response) => {
            if (response.data.ResultCode == 100) {
              //this.$alertify.success(response.data.ReturnMessage)
              this.$alert(response.data.ReturnMessage,"","success");
              user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
              this.RuleName = ''
              this.IsActive = false
              this.getActiveInactiveRuleDetails()
              this.getRuleList()
            } else {
              //this.$alertify.error(response.data.ReturnMessage)
              this.$alert(response.data.ReturnMessage,"","error");
              this.ShowShipmentRuleList = false
              this.ShowShipmentRuleForm = false
            }
            this.isLoading = false;
          })
          .catch((httpException) => {
            this.isLoading = false;
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    getRuleDetailsRawData(data) {
      this.ruleaction = 'edit'
      this.displayrulelist = true
      this.DisplayAddRuleForm = true
      this.ruleid = data.ruleid
      this.RuleName = data.rulename
      this.IsActive = data.isactive
    },
    CancelAddRuleForm() {
      if (this.DisplayAddRuleForm == true) {
        this.ShowShipmentRuleList = false
        this.ShowShipmentRuleForm = true
        this.DisplayAddRuleForm = false
        this.displayrulelist = false
      } else {
        this.ruleaction = 'add'
        this.IsActive = false
        this.RuleName = ''
        this.DisplayAddRuleForm = true
        this.displayrulelist = true
      }
    },
    ShowRuleList() {
      this.displayrulelist = true
      this.DisplayAddRuleForm = false
    },
    editRuleDetails() {
      if(!this.RuleName){
        this.checkRuleName();
        return false;
      }
      this.ruleaction = 'edit'
      this.input = {
        "ruleid": this.ruleid,
        "rulename": this.RuleName,
        "isActive": this.IsActive,
        "createdby": this.createdBy
      }
      this.isLoading = true;
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'updateShipmentRule',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","success");
            user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
            this.displayrulelist = true
            this.DisplayAddRuleForm = false
            this.getActiveInactiveRuleDetails()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","error");
          }
          this.isLoading = false;
        })
        .catch((httpException) => {
          this.isLoading = false;
          this.$alert("Error!!","","error");
          console.error('exception is:::::::::', httpException)
        })
    },
    openRuleModal(data) {
      this.rulemodaldata = data
      this.Rulemodal = true
    },
    closeRuleModal() {
      this.Rulemodal = false
    },
    activeInactiveStatus() {
      var olddata = this.rulemodaldata
      var newactStatus = this.rulemodaldata.isactive ? false : true
      var url = 'updateShipmentRule'
      this.input = {
        "ruleid": this.rulemodaldata.ruleid,
        "rulename": this.rulemodaldata.rulename,
        "createdby": this.createdBy,
        "isActive": newactStatus
      }
      this.isLoading = true;
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + url,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","success");
            user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
            this.getActiveInactiveRuleDetails()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","error");
          }
          this.isLoading = false;
        })
        .catch((httpException) => {
          this.isLoading = false;
          console.error('exception is:::::::::', httpException)
        })
    },
    getShipmentRouteDetailsList() {
      if(!this.ruleitem.id){
        return false
      }
      this.isLoading = true;
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getShipmentRouteModeRuleDetails?ruleId=' + this.ruleitem.id + (this.routemode ? '&routeMode=' + this.routemode : ''),
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.ShipmentRuleDetails = result.data.ResponseData;
            this.len = this.ShipmentRuleDetails.length
            this.ShowShipmentRuleList = true
          } else {
            this.ShowShipmentRuleList = false
            this.$alertify.error(result.data.ReturnMessage)
            //this.$alert(result.data.ReturnMessage,"","error");
          }
          if (this.shipmentruleaction == 'edit') {
            this.resetEditForm()
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    addShipmentRouteDetails() {
      if (this.ruleitem.text == '') {
        this.isRuleError = '1',
          this.Ruleerrors = 'The Rule Name field is required.'
        return false;
      } else {
        this.isRuleError = '',
          this.Ruleerrors = ''
      }
      if (this.checkMinWeight() == false) {
        return false;
      }
      if (this.checkMaxWeight() == false) {
        return false;
      }
      if (this.checkMinAmount() == false) {
        return false;
      }
      if (this.checkMaxAmount() == false) {
        return false;
      }
      this.input = {
        "ruleId": this.ruleitem.id,
        "routeMode": this.routemode,
        "serviceType": this.servicetype,
        "minWeight": this.minimumweight,
        "maxWeight": this.maximumweight,
        "shipmentType": this.shipmenttype,
        "createdBy": this.createdBy
      }
      if (this.minimumamount) {
        this.input.minAmount = this.minimumamount
      }
      if (this.maximumamount) {
        this.input.maxAmount = this.maximumamount
      }
      if (this.effectivefromdate != '') {
        this.input.expiryFromDate = this.getSelectedDate(this.effectivefromdate)
      }
      if (this.expirydate != '') {
        this.input.expiryToDate = this.getSelectedDate(this.expirydate)
      }
      if (this.ordertype != '') {
        this.input.orderType = this.ordertype
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'createShipmentRouteModeRuleDetails',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            this.getShipmentRouteDetailsList();
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","success");
            user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
            this.CancelShipmentForm()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getShipmentRowData(data) {
      this.shipmentruleaction = 'edit'
      this.shipmentid = data.shipmentruledetailsid
      this.ruleitem.id = data.ruleid
      this.ruleitem.text = data.rulename
      this.routemode = data.routemode
      this.servicetype = data.servicetype
      this.minimumweight = data.minweight
      this.maximumweight = data.maxweight
      this.shipmenttype = data.shipmenttype
      this.ordertype = data.ordertype
      this.minimumamount = data.minamount
      this.maximumamount = data.maxamount
      this.effectivefromdate = data.expiryfromdate
      this.expirydate = data.expirytodate
    },
    editShipmentRouteDetails() {
      if (this.checkMinWeight() == false) {
        return false;
      }
      if (this.checkMaxWeight() == false) {
        return false;
      }
      if (this.checkMinAmount() == false) {
        return false;
      }
      if (this.checkMaxAmount() == false) {
        return false;
      }
      this.input = {
        "ruleId": this.ruleitem.id,
        "routeMode": this.routemode,
        "serviceType": this.servicetype,
        "minWeight": this.minimumweight,
        "maxWeight": this.maximumweight,
        "shipmentType": this.shipmenttype,
        "orderType": this.ordertype ? this.ordertype : null,
        "minAmount": this.minimumamount ? this.minimumamount : null,
        "maxAmount": this.maximumamount ? this.maximumamount : null,
        "expiryFromDate": this.effectivefromdate ? this.effectivefromdate : null,
        "expiryToDate": this.expirydate ? this.expirydate : null,
        "createdBy": this.createdBy
      }
      this.isLoading = true;
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'updateShipmentRuleDetails',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        }).then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","success");
            this.CancelShipmentForm();
            this.getShipmentRouteDetailsList();
            user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","error");
          }
          this.isLoading = false;
        })
        .catch((httpException) => {
          this.isLoading = false;
          this.$alert("Error!!","","error");
          console.error('exception is:::::::::', httpException)
        })
    },
    getSelectedDate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    resetEditForm() {
      this.servicetype = ''
      this.shipmenttype = ''
      this.ordertype = ''
      this.minimumweight = ''
      this.maximumweight = ''
      this.minimumamount = ''
      this.maximumamount = ''
      this.effectivefromdate = ''
      this.expirydate = ''
      //this.ShowShipmentRuleList = false
      this.$validator.reset()
    },
    CancelShipmentRule(){
      this.ruleitem = {
        id: '',
        text: ''
      }
      this.CancelShipmentForm()
    },
    CancelShipmentForm() {
      this.routemode = ''
      this.servicetype = ''
      this.shipmenttype = ''
      this.ordertype = ''
      this.minimumweight = ''
      this.maximumweight = ''
      this.minimumamount = ''
      this.maximumamount = ''
      this.effectivefromdate = ''
      this.expirydate = ''
      this.minweightError = ''
      this.maxweightError = ''
      this.minamountError = ''
      this.maxamountError = ''
      this.ShowShipmentRuleList = false
      this.$validator.reset()
    },
    openStatusModal(data) {
      this.modaldata = data
      this.modalShow = true
    },
    closeStatusModal() {
      this.modalShow = false
    },
    //for active/inactive modal
    changeRuleStatus() {
      var newactStatus = this.modaldata.isactive ? false : true
      this.input = {
        "shipmentRuleDetailsId": this.modaldata.shipmentruledetailsid,
        "createdBy": this.createdBy,
        "isActive": newactStatus
      }
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'inActiveShipmentRouteModeRule',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then((response) => {
          if (response.data.ResultCode == 100) {
            //this.$alertify.success(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","success");
            user_tracker.checkUserIP(this.userData[0], "ShipmentRuleDetails", this.$route.path , this.input);
            this.getShipmentRouteDetailsList()
          } else {
            //this.$alertify.error(response.data.ReturnMessage)
            this.$alert(response.data.ReturnMessage,"","error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    checkMinWeight() {
      if (this.maximumweight != '') {
        var isErr = 0;
        if (parseFloat(this.minimumweight) > parseFloat(this.maximumweight)) {
          this.minweightError = 'Minimum Weight should be less than Maximum Weight.'
          isErr = 1;
        } else {
          this.minweightError = ''
          this.maxweightError = ''
        }
        if (isErr == 1) {
          return false;
        }
      }
    },
    checkMaxWeight() {
      if (this.minimumweight != '') {
        var isErr = 0;
        if (parseFloat(this.minimumweight) > parseFloat(this.maximumweight)) {
          this.maxweightError = 'Maximum Weight must be greater than Minimum Weight.'
          isErr = 1;
        } else {
          this.maxweightError = ''
          this.minweightError = ''
        }
        if (isErr == 1) {
          return false;
        }
      }
    },
    checkMinAmount() {
      if (this.maximumamount != '') {
        var isErr = 0;
        if (parseInt(this.minimumamount) > parseInt(this.maximumamount)) {
          this.minamountError = 'Minimum Amount should be less than Maximum Amount.'
          isErr = 1;
        } else {
          this.minamountError = ''
          this.maxamountError = ''
        }
        if (isErr == 1) {
          return false;
        }
      }
    },
    checkMaxAmount() {
      if (this.minimumamount != '') {
        var isErr = 0;
        if (parseInt(this.minimumamount) > parseInt(this.maximumamount)) {
          this.maxamountError = 'Maximum Amount must be greater than Minimum Amount.'
          isErr = 1;
        } else {
          this.maxamountError = ''
          this.minamountError = ''
        }
        if (isErr == 1) {
          return false;
        }
      }
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1) * 20;
      this.getShipmentRouteDetailsList();
    },
    cancelForm() {
      this.RuleName = ""
      this.isRuleNameError = ""
      this.RuleNameerrors = ""
      this.IsActive = false
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.shipmentruleaction == 'add') {
            this.addShipmentRouteDetails()
          }
          if (this.shipmentruleaction == 'edit') {
            this.editShipmentRouteDetails()
          }
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ShipmentRuleDetails/ShipmentRuleDetails.component.js